// extracted by mini-css-extract-plugin
export default {"form":"PasswordAuth_form__yqI1n","inputWrapper":"PasswordAuth_inputWrapper__Q1pFO","icon":"PasswordAuth_icon__AYADu","iconWithError":"PasswordAuth_iconWithError__N5Yah"};